import { ApolloError, FetchResult } from '@apollo/client';
import {
  useOfferDisplayCategoriesCreateOrUpdateMutation as useApolloOfferDisplayCategoriesCreateOrUpdateMutation,
  OfferDisplayCategoriesInput,
  OfferDisplayCategoriesCreateOrUpdateMutation,
} from '@occc/graphql';

export const useOfferDisplayCategoriesCreateOrUpdateMutation = (
  onCompleted?: (
    data: OfferDisplayCategoriesCreateOrUpdateMutation['offerDisplayCategoriesCreateOrUpdate'],
  ) => void,
  onError?: (error: ApolloError) => void,
): [
  (
    input: OfferDisplayCategoriesInput,
  ) => Promise<FetchResult<OfferDisplayCategoriesCreateOrUpdateMutation>>,
  boolean,
] => {
  const [createOrUpdate, { loading }] = useApolloOfferDisplayCategoriesCreateOrUpdateMutation({
    onCompleted: (data) => {
      if (onCompleted) {
        onCompleted(data.offerDisplayCategoriesCreateOrUpdate);
      }
    },
    onError,
  });

  return [
    (input) =>
      createOrUpdate({
        variables: { input },
      }),
    loading,
  ];
};
